import React from 'react';
import {Field} from 'redux-form';
import {connect} from 'react-redux';

function displayBookDetails( props ) {
    const { name, author, productcode } = props;
    return (
        <div className="gratisBookDetails">
            {name &&
            <div>
                <span className="gratisBookDetailLabel">Title:</span>
                <div className="gratisBookDetail" dangerouslySetInnerHTML={{ __html: name }}>
                </div>
            </div>
            }
            {author &&
            <div>
                <span className="gratisBookDetailLabel">Author:</span>
                <div className="gratisBookDetail" dangerouslySetInnerHTML={{ __html: author }}></div>
            </div>
            }
            {productcode &&
            <div>
                <span className="gratisBookDetailLabel">ISBN:</span>
                <div className="gratisBookDetail" dangerouslySetInnerHTML={{ __html: productcode }}></div>
            </div>
            }
        </div>
    )
}
function displayLoading() {
    return (
        <div className="gratisBookDetails">
            Loading...
        </div>
    );
}
function displayError( props ) {
    const { product: { productcode, error } } = props;
    return (
        <div>
            <div className="gratisBookDetails">
                Product not found: {productcode}
            </div>
            {props.office.config &&
            <div className="gratisBookDetails"
                 dangerouslySetInnerHTML={{ __html: props.office.config.bookNotAvailable }}>
            </div>
            }
        </div>
    );
}
class BookDetails extends React.Component {
    render() {
        let nodes;
        if ( !this.props.product ) {
            nodes = displayLoading();
        }
        else if ( this.props.product.error ) {
            nodes = displayError( this.props );
        }
        else {
            nodes = displayBookDetails( this.props.product );
        }
        return (
            <fieldset>
                <legend>Product Details</legend>
                {nodes}
            </fieldset>
        );
    }
}

export default connect( state => state )( BookDetails );


// WEBPACK FOOTER //
// ./src/form/components/BookDetails.jsx